export default __webpack_public_path__ + "b9aad0fd6156f47e187cb26099263fd4.svg";